// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__3w_1K","errorLogs":"EditorFooter_errorLogs__15qJK"};